import { useNavigate } from 'react-router';
import { useContext, useEffect } from 'react';
import styles from './Services.module.scss';
import { Heading } from '../../../ui/components/Heading/Heading';
import { Button } from '../../../ui/components/Button/Button';
import { Icon } from '../../../ui/components/Icon/Icon';
import { useGQLLazyQuery } from '../../../ui/utils/graphql';
import { GET_SERVICES } from '../../../graphql/service';
import { Service } from '../../../gql/graphql';
import { InitialContext } from '../../Layout/Layout';

export const Services = () => {
  const navigate = useNavigate();
  const context = useContext(InitialContext);
  const { data, lazy } = useGQLLazyQuery<Service[], { companyId: string }>(
    GET_SERVICES
  );

  useEffect(() => {
    if (context.company) {
      lazy({
        variables: {
          companyId: context.company.id,
        },
      });
    }
  }, [context.company]);

  const renderSubservices = (childrens: Service[]) => {
    if (childrens?.length === 0) {
      return (
        <div className={styles['no-subservices']}>
          No hay subservicios creados
        </div>
      );
    }

    return childrens.map((children) => (
      <div key={children.id} className={styles['sub-container']}>
        <div className={styles.header}>
          <p className={styles.title}>{children.name}</p>
          <Button className={styles['edit-subservice']}>
            <Icon type="edit2" />
          </Button>
        </div>
        <div className={styles['info-container']}>
          <div className={styles['desc-item']}>
            <div className={styles.title}>
              <Icon type="money" />
            </div>
            <div className={styles.value}>{`${children.price} MXN`}</div>
          </div>
          <div className={styles['desc-item']}>
            <div className={styles.title}>
              <Icon type="clock" />
            </div>
            <div className={styles.value}>{`${
              children.durationInSec / 60
            } min`}</div>
          </div>
        </div>
      </div>
    ));
  };

  const renderServices = () => {
    return data?.map((service) => (
      <div key={service.id} className={styles.service}>
        <div className={styles['main-service']}>
          <div className={styles.title}>{service.name}</div>
          <div className={styles.actions}>
            <Button
              className={styles.button}
              onClick={() => navigate(`/services/create?service=${service.id}`)}
            >
              <Icon type="add" />
              <div>Nuevo subservicio</div>
            </Button>
            <Button
              onClick={() => navigate(`/services/edit/${service.id}`)}
              className={styles['edit-button']}
            >
              <Icon type="edit2" />
            </Button>
          </div>
        </div>
        <div className={styles.description}>
          <div className={styles['desc-item']}>
            <div className={styles.title}>
              <Icon type="money" />
              <div className={styles.label}>Precio: </div>
            </div>
            <div className={styles.value}>{`${service.price} MXN`}</div>
          </div>
          <div className={styles['desc-item']}>
            <div className={styles.title}>
              <Icon type="clock" />
              <div className={styles.label}>Duración:</div>
            </div>
            <div className={styles.value}>{`${
              service.durationInSec / 60
            } min`}</div>
          </div>
        </div>
        <div className={styles['sub-services']}>
          {/* <Heading headingLevel="h3" className={styles['sub-service']}>
            Subservices
          </Heading> */}
          <div className={styles['subservices-container']}>
            {renderSubservices(service.Childrens)}
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Heading className={styles.heading} headingLevel="h1">
          Mis servicios
        </Heading>
      </div>
      <div className={styles.actions}>
        <Button
          onClick={() => navigate('/services/create')}
          className={styles.action}
        >
          Añadir nuevo servicio
        </Button>
      </div>
      <p className={styles.description}>
        El precio final de los servicios es mostrado por el servicio si es que
        el servicio no tiene subservicios o en su defecto el de los subservicios
      </p>
      <div className={styles.services}>
        {/* <div className={styles['table-header']}>
          <div className={styles.service}>Servicio</div>
          <div className={styles.subservice}>Subservicio</div>
        </div> */}
        {renderServices()}
      </div>
    </div>
  );
};
